/**
 * Before → after, inline: each changed phrase struck in red, then its
 * replacement in green (see `diffPhrases`).
 *
 * @module components/regulation/finding/changes/InlineDiff
 */
import { Fragment } from "react";

import { cn } from "~/lib/utils";
import { diffPhrases } from "./wordDiff";

export function InlineDiff({ before, after, className }: { readonly before: string; readonly after: string; readonly className?: string | undefined }) {
  const segments = diffPhrases(before, after);
  return (
    <p className={cn("whitespace-pre-wrap break-words text-sm leading-6", className)} data-inline-diff="">
      {segments.map((segment, index) =>
        segment.kind === "same" ? (
          <span key={index}>{segment.text}</span>
        ) : segment.kind === "del" ? (
          <Fragment key={index}>
            <del className="rounded-[3px] bg-red-500/10 text-red-700 decoration-red-500/60 [box-decoration-break:clone] dark:bg-red-500/15 dark:text-red-300">
              {segment.text.trimEnd()}
            </del>
            {segments[index + 1]?.kind === "add" || /\s$/.test(segment.text) ? " " : null}
          </Fragment>
        ) : (
          <ins
            key={index}
            className="rounded-[3px] bg-emerald-500/12 text-emerald-800 no-underline [box-decoration-break:clone] dark:bg-emerald-500/15 dark:text-emerald-200"
          >
            {segment.text}
          </ins>
        ),
      )}
    </p>
  );
}
